/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove player" |
*
* @param {Players_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_remove_title = /** @type {((inputs?: Players_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Remove_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer le joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi giocatore")
	return /** @type {LocalizedString} */ ("Remove player")
});